﻿
export class Direcciones {

    public Id: number;
    public DIRECCION: string;
    public CODIGO_POSTAL: number;
    public POBLACION: string;
    public PROVINCIA: string;
    public ID_PROVINCIA: number;
    public TELEFONO: string;
    ID_USUARIO: number;
    EDITABLE: boolean;

    public NOMBRE: string; // nombre descriptivo
    //    public DEFAULT: boolean; // si es la dirección pro defectoç
    public POR_DEFECTO: boolean; // si es la dirección pro defecto
    public DEFAULT: boolean; // FIXME: Cuando se obtienen las direcciones a partir de un servicio del usuario, el campo se denomina DEFAULT
    constructor() { }

    static toModel(json: string): Direcciones {
        const toReturn = new Direcciones();
        const data = JSON.parse(json);
        toReturn.Id = data.Id;
        toReturn.DIRECCION = data.DIRECCION;
        toReturn.CODIGO_POSTAL = data.CODIGO_POSTAL;
        toReturn.POBLACION = data.POBLACION;
        toReturn.PROVINCIA = data.PROVINCIA;
        toReturn.ID_PROVINCIA = data.ID_PROVINCIA;
        toReturn.TELEFONO = data.TELEFONO;
        toReturn.DEFAULT = data.DEFAULT;
        toReturn.NOMBRE = data.NOMBRE; // R2_USUARIO_DIRECCION O R2_DIRECCIONES
        // toReturn.DEFAULT = data.POR_DEFECTO; // R2_USUARIO_DIRECCION

        toReturn.DEFAULT = data.DEFAULT;
        toReturn.POR_DEFECTO = data.POR_DEFECTO; // R2_USUARIO_DIRECCION
        toReturn.EDITABLE = data.EDITABLE;
        if (data.ID_USUARIO) {
            toReturn.ID_USUARIO = data.ID_USUARIO;
        }
        return toReturn;
    }
}

